/**
 * UUID utility functions
 */

/**
 * Check if a string looks like a UUID (v4 format)
 */
export const isUUID = (value: string): boolean => {
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidPattern.test(value);
};

/**
 * Generate a v4 UUID for client-side idempotency keys (e.g. portal message
 * client_message_id). Prefers the Web Crypto API; falls back to a
 * Math.random-based generator where crypto.randomUUID is unavailable
 * (older browsers, and the CRA jest/jsdom test environment).
 */
export const generateUuid = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
